import styled from '@emotion/styled'

// 总的提示框样式
const StyledToast = styled.div`
  position: fixed;
  background: #fff;
  /* border:5px solid pink; */
  max-width: 300px;
  max-height: 88px;
  bottom: ${(notice) => {
    const { position } = notice
    if (position) {
      const bottom = position.split(' ')[0]
      console.log(bottom + '---bottom')
      if (bottom === 'center' || bottom === 'bottom') {
        return 0
      }
      return ''
    }
    return ''
  }};
  top: ${(notice) => {
    const { position } = notice
    if (position) {
      const top = position.split(' ')[0]
      console.log(top + '---top')
      if (top === 'top' || top === 'center') {
        return 0
      }
      return ''
    }
    return 0
  }};
  left: ${(notice) => {
    const { position } = notice
    if (position) {
      const left = position.split(' ')[1]
      console.log(left + '---left')
      if (left === 'left' || left === 'center') {
        return 0
      }
      return ''
    }
    return 0
  }};
  right: ${(notice) => {
    const { position } = notice
    if (position) {
      const right = position.split(' ')[1]
      console.log(right + '---right')
      if (right === 'center' || right === 'right') {
        return 0
      }
      return ''
    }
    return 0
  }};
  margin: auto;
  box-sizing: border-box;

  .toast-loading {
    -webkit-animation: loading 1s steps(12, end) infinite;
    animation: loading 1s steps(12, end) infinite;
  }
  .message-notice-content {
    background: #fff;
    max-width: 300px;
    border-radius: 0.25rem;
    border: 1px solid rgba(0, 0, 0, 0.1);
    /* box-shadow: 0 0.25rem 0.75rem rgb(0 0 0 / 10%); */
  }

  @-webkit-keyframes loading {
    0% {
      -webkit-transform: rotate3d(0, 0, 1, 0deg);
      transform: rotate3d(0, 0, 1, 0deg);
    }
    100% {
      -webkit-transform: rotate3d(0, 0, 1, 360deg);
      transform: rotate3d(0, 0, 1, 360deg);
    }
  }

  @keyframes loading {
    0% {
      -webkit-transform: rotate3d(0, 0, 1, 0deg);
      transform: rotate3d(0, 0, 1, 0deg);
    }
    100% {
      -webkit-transform: rotate3d(0, 0, 1, 360deg);
      transform: rotate3d(0, 0, 1, 360deg);
    }
  }
`

export default StyledToast
